import React from 'react';
import {View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import Button from '../../components/themed/Button';
import Text from '../../components/themed/Text';
import ContentView from '../../components/ui-controls/layout/ContentView';
import config from '../../config';
import CelebrationIcon from '../../images/brand/svg/icons/Celebration.svg';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';

const RewardsFullSuccessScreen = observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.REWARDS_FULL_SUCCESS>) => {
    return (
      <KeyboardAwareScrollView
        style={{backgroundColor: 'white'}}
        keyboardShouldPersistTaps="always">
        <ContentView>
          <View
            style={{
              padding: 20,
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <CelebrationIcon width={113} height={115} />
          </View>
          <Text variant="heading1">Congrats!</Text>
          <Text variant="body2">
            Your account and rewards card is ready to go! Start shopping online
            now or see what’s on sale now for members by signing in below with
            your credentials
          </Text>
          <View style={{gap: 8, marginTop: 40}}>
            <Button
              title={'Sign in'}
              // onPress={handleSubmitPress}
              // disabled={isSubmitting}
              // loading={isSubmitting}
            />
            <Button
              secondary
              title={`GO TO ${_.toUpper(config.APP_NAME)} HOME`}
              onPress={() => {
                navigation.navigate(AppRoute.ROOT_STORE_SELECTION_FLOW);
              }}
            />
          </View>
        </ContentView>
      </KeyboardAwareScrollView>
    );
  },
);

export default RewardsFullSuccessScreen;
